import http from '../api/http';
import {
  API_INVENTARIOS,
  API_INVENTARIO_ITENS,
  API_INVENTARIO_ADICIONAR_ITENS,
  API_INVENTARIO_VALIDAR_BARCODE,
} from '../api/apiConfig';
import {
  Inventario,
  ItemInventario,
  AdicionarItensInventarioRequest,
  ValidarBarcodeInventarioRequest,
  ValidarBarcodeInventarioResponse,
} from '../types/inventario';
import { createCrudService } from './crudFactory';

export const inventariosService = createCrudService<Inventario>(API_INVENTARIOS);
export const inventarioItensService = createCrudService<ItemInventario>(API_INVENTARIO_ITENS);

export const inventarioService = {
  ...inventariosService,

  adicionarItens: async (
    inventarioId: number | string,
    data: AdicionarItensInventarioRequest
  ): Promise<Inventario> => {
    const response = await http.post(API_INVENTARIO_ADICIONAR_ITENS(inventarioId), data);
    return response.data;
  },

  validarBarcode: async (
    data: ValidarBarcodeInventarioRequest
  ): Promise<ValidarBarcodeInventarioResponse> => {
    const response = await http.post(API_INVENTARIO_VALIDAR_BARCODE, data);
    return response.data;
  },

  getItens: async (inventarioId: number | string): Promise<ItemInventario[]> => {
    const response = await http.get(API_INVENTARIO_ITENS, {
      params: { inventario: inventarioId },
    });
    return response.data.results || response.data;
  },
};
